import {ActivityIndicator, TouchableOpacity, View} from "react-native";
import FontAwesome from "./FontAwesome";
import Text from "./Text";
import React, {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {CartContext} from "../../../contexts/CartContext";
import {MenuActionButtonStyles} from "../styles";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";
import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import colors from "native-base/lib/typescript/theme/base/colors";

export function CartPageActionButton(props: { grow: number, menuDetails: MenuDetails}) {
    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instanceNoServerColor(appConfigContext.theme, "#376864");
    const cart = useContext(CartContext);
    const appFunctions = useContext(AppFunctionsContext);

    const lStyle = MenuActionButtonStyles(color);

    return <TouchableOpacity style={[lStyle.cartButtonContainer, {
        flexGrow: props.grow,
        borderRadius:15,
        shadowRadius: 8,
        shadowOpacity: .5,
        shadowColor: color.get("primaryColor") as string,
        shadowOffset: {
            width: 0,
            height: 3,
        }
    }]} onPress={()=>{
        appFunctions.functions.goToCartPage(props.menuDetails)
    }}>
        <View style={{
            flexGrow: 1,
            justifyContent: "space-between",
        }}>
            <Text style={{paddingTop: 2}} color={"white"} weight={700} size={14}>سفارش من</Text>
            <Text color={"white"} weight={400}>{`${cart.allItemsPrice} ت`}</Text>
        </View>
        <View style={{
            alignItems: "center",
            justifyContent: "space-between",
        }}>
            <View style={{paddingBottom: 7}}>
                <FontAwesome
                    containerStyle={{opacity: cart.isFetching ? 0 : 1}} icon={''} color={"#fff"} type={"solid"}
                    size={20}/>
                <ActivityIndicator style={{position: "absolute", display: cart.isFetching ? "flex" : "none"}}
                                   color={"white"} size={20}/>
            </View>
            <Text color={"white"} size={12} weight={500}>{`${cart.allItemsCount} آیتم`}</Text>
        </View>
    </TouchableOpacity>
}

export function ProfilePageActionButton(props: { grow: number}) {

    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instanceNoServerColor(appConfigContext.theme, useContext(AppConfigContext).color);

    const lStyle = MenuActionButtonStyles(color);
    const appFunctions = useContext(AppFunctionsContext);

    return <TouchableOpacity onPress={appFunctions.appNavigator.toUserMenu} style={[lStyle.profileButtonContainer, {
        flexGrow: props.grow,
        backgroundColor: color.get("highConHeader") as string,
        borderWidth:1,
        borderRadius:15,
        borderColor: color.get("primaryColor") as string,
        shadowRadius: 8,
        shadowOpacity: .5,
        shadowColor: color.get("primaryColor") as string,
        shadowOffset: {
            width: 0,
            height: 3,
        }
    }]}>
        <FontAwesome icon={''} color={color.get("primaryColor") as string} type={"solid"} size={20}/>
        <Text color={color.get("primaryColor") as string} size={12} weight={500}>منوی کاربری</Text>
    </TouchableOpacity>
}

export function ServicesPageActionButton(props: { grow: number, color: "red" | "yellow" | "green" }) {
    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instanceNoServerColor(appConfigContext.theme, appConfigContext.color);
    const cart = useContext(CartContext);
    const appFunctions = useContext(AppFunctionsContext);

    const lStyle = MenuActionButtonStyles(color);

    return <TouchableOpacity style={[lStyle.servicesButtonContainer, {
        flexGrow: props.grow,
        backgroundColor: color.get(props.color) as string,
        borderRadius:15,
        shadowRadius: 8,
        shadowOpacity: .5,
        shadowColor: color.get(props.color) as string,
        shadowOffset: {
            width: 0,
            height: 3,
        }
    }]} onPress={appFunctions.appNavigator.toServices}>
        <FontAwesome containerStyle={{opacity: cart.isFetching ? 0 : 1}} icon={''} color={"#fff"} type={"solid"}
                     size={20}/>
        <Text color={"white"} size={12} weight={500}>منوی خدمات</Text>
    </TouchableOpacity>
}

export function GamesPageActionButton(props: { grow: number}) {
    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instanceNoServerColor(appConfigContext.theme, useContext(AppConfigContext).color);
    const cart = useContext(CartContext);
    const appFunctions = useContext(AppFunctionsContext);

    const lStyle = MenuActionButtonStyles(color);


    return <TouchableOpacity onPress={appFunctions.appNavigator.toGames} style={[lStyle.gameButtonContainer, {
        flexGrow: props.grow,
        backgroundColor: color.get("highConHeader") as string,
        borderRadius:15,
        borderWidth:1,
        borderColor: color.get("primaryColor") as string,
        shadowRadius: 8,
        shadowOpacity: .5,
        shadowColor: color.get("primaryColor") as string,
        shadowOffset: {
            width: 0,
            height: 3,
        }
    }]}>
        <FontAwesome containerStyle={{opacity: cart.isFetching ? 0 : 1}} icon={''} color={color.get("primaryColor") as string} type={"solid"}
                     size={20}/>
        <Text color={color.get("primaryColor") as string} size={12} weight={500}>حوصلم سر رفت!</Text>
    </TouchableOpacity>
}

export function WaiterCallButton(props: { grow: number }) {
    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instanceNoServerColor(appConfigContext.theme, appConfigContext.color);
    const cart = useContext(CartContext);

    const lStyle = MenuActionButtonStyles(color);
    const appFunctions = useContext(AppFunctionsContext);


    return <TouchableOpacity style={[lStyle.gameButtonContainer, {
        flexGrow: props.grow,
        backgroundColor: color.get("highConHeader") as string,
        borderRadius:15,
        shadowRadius: 8,
        shadowOpacity: .5,
        shadowColor: color.get("primaryColor") as string,
        shadowOffset: {
            width: 0,
            height: 3,
        }
    }]} onPress={appFunctions.functions.waiterCall}>
        <FontAwesome containerStyle={{opacity: cart.isFetching ? 0 : 1}} icon={''} color={"#fff"} type={"solid"}
                     size={20}/>
        <Text color={"white"} size={12} weight={500}>فراخوانی گارسون</Text>
    </TouchableOpacity>
}